import { Check, Clock, X } from "lucide-react";
import { formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const HEAD = "label-overline text-amber-800";

const PendingRow = ({ c, busy, onApprove, onReject }) => (
  <TableRow data-testid={`pending-row-${c.id}`} className="bg-transparent">
    <TableCell className="font-medium text-slate-900">{c.name}</TableCell>
    <TableCell className="font-mono-num text-slate-700">{c.mobile}</TableCell>
    <TableCell className="text-sm text-slate-500">{formatDate(c.created_at)}</TableCell>
    <TableCell className="text-right">
      <div className="inline-flex gap-2">
        <Button size="sm" disabled={busy} onClick={() => onApprove(c.id)} data-testid={`approve-${c.id}`}
          className="bg-emerald-700 hover:bg-emerald-800 gap-1">
          <Check className="h-3.5 w-3.5" /> Approve
        </Button>
        <Button size="sm" variant="outline" disabled={busy} onClick={() => onReject(c.id)} data-testid={`reject-${c.id}`}
          className="border-red-300 text-red-700 hover:bg-red-50 gap-1">
          <X className="h-3.5 w-3.5" /> Reject
        </Button>
      </div>
    </TableCell>
  </TableRow>
);

export const PendingApprovals = ({ pending, busyId, onApprove, onReject }) => {
  if (pending.length === 0) return null;
  return (
    <section data-testid="pending-section" className="bg-amber-50 border border-amber-200 rounded-lg overflow-hidden">
      <div className="px-6 py-5 border-b border-amber-200 flex items-center justify-between">
        <div>
          <p className="label-overline text-amber-700">Action required</p>
          <h2 className="font-display text-xl font-bold text-slate-900 mt-1 flex items-center gap-2">
            <Clock className="h-5 w-5 text-amber-700" />
            Pending registrations
          </h2>
        </div>
        <Badge variant="outline" className="font-mono-num bg-white">{pending.length} waiting</Badge>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="bg-amber-100/50 hover:bg-amber-100/50">
            <TableHead className={HEAD}>Name</TableHead>
            <TableHead className={HEAD}>Mobile</TableHead>
            <TableHead className={HEAD}>Registered</TableHead>
            <TableHead className={`${HEAD} text-right`}>Decision</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {pending.map((c) => (
            <PendingRow key={c.id} c={c} busy={busyId === c.id} onApprove={onApprove} onReject={onReject} />
          ))}
        </TableBody>
      </Table>
    </section>
  );
};
